import blue from '@mui/material/colors/blue';
import orange from '@mui/material/colors/orange';

export const DRAWER_WIDTH = 250;

export default theme => ({
  root: {
    marginTop: theme.spacing(3),
    width: '100%'
  },
  appBar: {
    backgroundColor:
      __CLIENT__ && /akutbolig/.test(window.location.host)
        ? orange[800]
        : blue[500]
  },
  drawerPaper: {
    width: DRAWER_WIDTH
  },
  flex: {
    flex: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  }
});
